
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  
  const navItems = [
    { path: '/', label: 'トップ' },
    { path: '#mission', label: 'ミッション' },
    { path: '#works', label: '事業内容' },
    { path: '#ceo', label: 'メッセージ' },
    { path: '#company', label: '会社概要' },
    { path: '#faq', label: 'よくある質問' },
    { path: '#contact', label: 'お問い合わせ' }
  ];

  const handleNavClick = (path: string) => {
    if (path === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (path.startsWith('#')) {
      const element = document.querySelector(path);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  const handleContactClick = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* ロゴ */}
          <Link to="/" className="flex items-center space-x-2" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img 
              src="https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/3f1e2363da69610ccf892d613395bdf1.png" 
              alt="ナインバレー株式会社" 
              className="h-[4rem] lg:h-16 w-auto"
            />
          </Link>
          
          {/* デスクトップナビゲーション */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.path}
                onClick={() => handleNavClick(item.path)}
                className={`text-sm font-medium transition-colors duration-200 cursor-pointer ${
                  (item.path === '/' && location.pathname === '/')
                    ? 'text-[#0B3D91] border-b-2 border-[#0B3D91] pb-1'
                    : 'text-gray-600 hover:text-[#0B3D91]'
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>
          
          {/* CTA ボタン */}
          <div className="hidden lg:flex items-center space-x-4">
            <Button size="sm" variant="secondary" className="text-sm whitespace-nowrap cursor-pointer" onClick={handleContactClick}>
              取材・共同事業のご相談
            </Button>
          </div>
          
          {/* モバイルメニューボタン */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-md text-gray-600 hover:text-[#0B3D91] hover:bg-gray-50 cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </div>
          </button>
        </div>
        
        {/* モバイルメニュー */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <button
                  key={item.path}
                  onClick={() => handleNavClick(item.path)}
                  className={`text-base font-medium transition-colors duration-200 text-left cursor-pointer ${
                    (item.path === '/' && location.pathname === '/')
                      ? 'text-[#0B3D91]'
                      : 'text-gray-600 hover:text-[#0B3D91]'
                  }`}
                >
                  {item.label}
                </button>
              ))}
              <div className="flex flex-col space-y-3 pt-4">
                <Button size="sm" variant="secondary" className="whitespace-nowrap cursor-pointer" onClick={handleContactClick}>取材・共同事業のご相談</Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
